export default __webpack_public_path__ + "static/media/addon2.fa77d4b0.webp";